<template>
  <div class="level-item-container">
    <div class="header">
      <div class="bg" :style="{ backgroundColor: info && filterColor(info.type) || '' }"></div>
      <svg-icon :icon-class="`diamond_${info && info.type || ''}`" class-name="diamond"></svg-icon>
      <span class="header-title">{{ info.type }}</span>
    </div>
    <div class="level-intro">
      <div class="left-info">
        <img :src="`/playDetails/characterDetails/${info.type}.png`" alt="">
      </div>
      <div class="right-info">
        <div class="info-item" v-for="item in info.list" :key="item.title">
          <div class="title">{{ item.title }}</div>
          <div class="sub-title">{{ item.summary }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WeaponQualityColorDict } from "@/utils/dict";

export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {}
  },
  mounted() { },
  methods: {
    filterColor(type) {
      const info = WeaponQualityColorDict.find(item => item.label == type);
      return info ? info.value : "";
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>